import {atom, selector} from 'recoil';

const playerState = atom({
  key: 'playerState',
  default: {
    muted: true,
    fullscreen: false,
    qualities: null,
    selectedQuality: null,
    tracks: null,
    selectedTrack: null,
  },
});


export default playerState;
